export default __webpack_public_path__ + "static/media/ic_libya.7dfde37d.svg";